import CkIcon from './CkIcon.js'

export default CkIcon
